module.exports = __webpack_public_path__ + "img/solution3.583fcfd9.png";